import { View } from 'react-native';
import { Image } from 'shared/components/image';
import { staticImage } from 'shared/library/static-images';

const fredrikAvatar = '/team/fredrik-livijn.jpg';
const andreAvatar = staticImage('andre');

export function TeamAvatars() {
  return (
    <View className={'w-16 shrink-0 flex-row'}>
      <Image
        src={fredrikAvatar}
        alt={'Fredrik Livijn'}
        containerClassName={
          'relative z-10 size-10 overflow-hidden rounded-full border-2 border-white bg-white'
        }
        imageClassName={'rounded-full object-cover'}
        sizeType={'avatar'}
      />
      <Image
        src={andreAvatar}
        alt={'André Andersson'}
        containerClassName={
          'relative -ml-4 size-10 overflow-hidden rounded-full border-2 border-white bg-white'
        }
        imageClassName={'rounded-full object-cover'}
        sizeType={'avatar'}
      />
    </View>
  );
}
